import { createContext, useContext } from 'react';

import { Account } from './types';

export interface WorkspaceContext {
  accounts: Account[];
  user: { email: string; emailVerified: boolean } | null;
}

const defaultContextValue = Symbol();

export const WorkspaceContext = createContext<WorkspaceContext | typeof defaultContextValue>(
  defaultContextValue,
);

export const useWorkspaceContext = () => {
  const context = useContext(WorkspaceContext);
  if (context === defaultContextValue) {
    throw new Error('useWorkspaceContext must be used within a WorkspaceContextProvider');
  }
  return context;
};
